'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const isUndefined$1 = require('../../predicate/isUndefined.js');

function isUndefined(x) {
    return isUndefined$1.isUndefined(x);
}

exports.isUndefined = isUndefined;
